import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree,
} from "@angular/router";
import { Observable, of } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { AuthService } from "../auth/auth.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> {
    const url: string = state.url;
    return this.checkLogin(url);
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> {
    return this.canActivate(route, state);
  }

  checkLogin(url: string): boolean | UrlTree | Observable<boolean | UrlTree> {
    if (this.authService.isLoggedIn()) {
      return true;
    }

    this.authService.redirectUrl = url;
    const loginTree = this.router.createUrlTree(["/login"], {
      queryParams: { returnUrl: url },
    });

    // Access token expired but refresh token still valid: refresh silently
    // instead of bouncing the user to the login screen.
    if (this.authService.isRefreshTokenValid()) {
      return this.authService.refreshAccessToken().pipe(
        tap(() => this.authService.startTokenAutoRefresh()),
        map(() => true),
        catchError(() => of(loginTree)),
      );
    }

    return loginTree;
  }
}
